import React from 'react';
import {toast} from "react-toastify";
import {word} from "../../word.js";

function ErrorToast(text) {
    return toast.error(text || word.error_process, {position: "top-center", theme: "colored",});
}

export default ErrorToast;